import React from 'react'
import CarOverviewListItem from "app/React/Components/CarOverview/CarOverviewListItem";

export default function CarOverviewList({ list }) {
  if (list === undefined || list.length === 0) {
    return null
  }

  return (
    <div className='car-overview__list'>
      {list.map((item, index) => <CarOverviewListItem key={index} {...item} />)}
    </div>
  )
}
